
export interface AccountantDateRange {
  start_date: string;
  end_date: string;
}

export interface AccountantReportQuery {
  search: string;
  filters: Record<string, string>;
}

export type AccountantSummaryPayload = AccountantDateRange & AccountantReportQuery;

export interface SummaryResponse {
  total_orders: number;
  total_cost: number;
  total_sale: number;
  total_profit: number;
  total_cash_received: number;
}

export interface AccountantShippingCompany {

  id: string;
  name: string;
  slug: string;
  has_api: boolean;

}

interface Pagination {
  total_records: number;
  total_pages: number;
  page: number;
  limit: number;
}

export interface AccountantOrders{
  pagination: Pagination;
  records: AccountantOrder[];
}

export interface AccountantOrder {
  id: string;
  return_id?: string;
  type?: 'order' | 'return';
  status: string;
  created_at: string;
  cached_payment_method: string;
  cached_shipping_method: string | null;
  cached_shipping_company: string | null;
  sub_total: number;
  total_cost: number;
  total_profit: number;
  grand_total: number;
  discount: number | null;
  handling_fee: number | null;
  shipping_fee: number | null;
  items_count: number;
  cached_customer_name: string | null;
  shipping_company_id: string | null;
  tracking_number: string | null;
  accountant_delivery_charge: string | null;
  accountant_note: string | null;
  shipping_company: string | null;
  order_items: AccountantOrderItem[];
  return_items?: AccountantReturnItem[];
  cash_received: number;
  row_key?: string;
}


interface ProductVariant {
  id: string;
  partner_sku: string;
  barcode: string;
  quantity_available: number;
  weight_value: number | null;
  weight_unit: string | null;
  product: {
    id: string;
  };
  product_variant_translations: {
    name: string;
  }[];
  product_variant_gallery: {
    image_thumbnail_url: string;
    image_gallery_urls?: string[];
  };
}

export interface AccountantOrderItem {
  id: string;
  product_variant_id: string;
  quantity: number;
  unit_price: number;
  cost_price: number;
  vat_amount: string;
  total_cost: number;
  total?: number;
  subtotal: number;
  profit_per_unit: number;
  remaining_stock?: number;
  product_variant: ProductVariant;
}

export interface AccountantReturnItem {
  id: string;
  return_id?: string;
  order_id?: string;
  order_item_id?: string;
  product_variant_id: string;
  cache_product_name?: string | null;
  item_price?: number;
  quantity: number;
  reason?: string;
  request_status?: string;
  refund_status?: string;
  rejected_reason?: string | null;
  cost_price?: number;
  total_cost?: number;
  unit_price?: number;
  deduction_amount?: number;
  subtotal?: number;
  total?: number;
  profit_per_unit?: number;
  product_variant: ProductVariant;
}